import { SliderCustomIconComponent } from './slider-custom-icon/slider-custom-icon.component';
import { SingleSliderComponent } from './single-slider/single-slider.component';
import { SliderTicksLabelsComponent } from '@app/shared/slider/slider-ticks-labels/slider-ticks-labels.component';

export {
  SliderCustomIconComponent,
  SingleSliderComponent,
  SliderTicksLabelsComponent
};



// WEBPACK FOOTER //
// ./src/app/shared/slider/index.ts